import { get } from './api';

export const proteinAPI = {
  getProteins() {
    return get('admin/proteins');
  },
};